module.exports = {"522301001":"黄草街道","522301002":"兴泰街道","522301003":"桔山街道","522301004":"丰都街道","522301005":"坪东街道","522301006":"木贾街道","522301007":"下五屯街道","522301008":"万峰林街道","522301009":"洒金街道","522301010":"马岭街道","522301011":"顶效街道","522301012":"木陇街道","522301100":"敬南镇","522301101":"泥凼镇","522301102":"南盘江镇","522301103":"捧乍镇","522301104":"鲁布格镇","522301105":"三江口镇","522301106":"乌沙镇","522301107":"白碗窑镇","522301109":"威舍镇","522301110":"清水河镇","522301112":"郑屯镇","522301113":"万屯镇","522301114":"鲁屯镇","522301115":"仓更镇","522301116":"七舍镇","522301117":"则戎镇","522301118":"猪场坪镇","522301201":"沧江乡","522301202":"洛万乡","522301204":"雄武乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522301.json
// module id = 2635
// module chunks = 0